import moment from "moment";
import React, { useEffect, useState } from "react";
import H1 from "../H1";
import H2 from "../H2";

export default function TimeOfDay({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const [t, setT] = useState();

	useEffect(() => {
		let intervalId;
		clearInterval(intervalId);

		intervalId = 
			setInterval(() => {
				let now = moment();
				setT(now);
			}, 100)

		return () => {
			clearInterval(intervalId);
		};
	}, []);

	if (cuePreview) {
		return <> {moment(t).format(cue.format || "HH:mm:ss")}</>;
	}

	return (
		<>
			{cue.pre && (
				<H2
					cue={cue}
					text={cue.pre}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
				/>
			)}
			<H1
				cue={cue}
				text={moment(t).format(cue.format || "HH:mm:ss")}
				baseTheme={baseTheme}
				baseThemeId={baseThemeId}
				tabular={true}
			/>
		</>
	);
}
